import { HTMLAttributes, ReactNode } from 'react';

import { Columns, ColumnsItem, Price, PriceLevel, Text, TextLevels, Title, TitleLevels } from '@bytel/trilogy-react-ts';

interface ListItemWithPriceProps extends HTMLAttributes<HTMLDivElement> {
    title?: string;
    amount: number;
    period?: string;
    subTitle?: string | ReactNode;
    subTitleClassName?: string;
    titleClassName?: string;
    className?: string;
    priceClassName?: string;
    priceLevel?: number;
    children?: ReactNode;
    showCents?: boolean;
    mainTitle?: string | ReactNode;
}
export function ListItemWithPrice({
    title,
    subTitle,
    subTitleClassName = '',
    titleClassName = '',
    amount,
    period,
    children,
    className = '',
    priceLevel = PriceLevel.LEVEL6,
    priceClassName,
    showCents = true,
    mainTitle,
}: Readonly<ListItemWithPriceProps>) {
    return (
        <Columns mobile className={className} verticalCentered>
            <ColumnsItem>
                <Title marginless level={TitleLevels.THREE} className={titleClassName}>
                    {mainTitle}
                </Title>
                {title && (
                    <Text marginless level={TextLevels.ONE} className={titleClassName}>
                        {title}
                    </Text>
                )}
                {subTitle && (
                    <Text marginless level={TextLevels.TWO} className={subTitleClassName}>
                        {subTitle}
                    </Text>
                )}
                {children}
            </ColumnsItem>
            <ColumnsItem narrow className='has-text-right'>
                <Price
                    amount={amount}
                    showCents={showCents}
                    period={period}
                    level={priceLevel}
                    className={priceClassName}
                />
            </ColumnsItem>
        </Columns>
    );
}
